import React from "react";
import { Row, Col, Button, Modal, ModalBody, ModalFooter } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

import "./Login.less";

class MfaErrorModal extends React.Component {

  handleBackToLoginClick = () => {
    this.props.handleMfaBackToLoginClick();
  };

  render() {
    return (
      <Modal isOpen={this.props.show} className="mfaModal" backdrop="static">
        <ModalBody>
          <Row>
            <Col md={12} className="text-left">
              <label className="MfaTitleLabel">{getMessage("MFA_ERROR_TITLE")}</label>
            </Col>
          </Row>
          <Row>
            <label className="MfaMsgLabel text-left autoHeight">
              {getMessage(this.props.errorMessageMfa)}</label>
          </Row>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          <Button
            className="customBtn borderBtn whiteOnClick"
            onClick={()=>this.handleBackToLoginClick()}
          >
            {getMessage("BACK_TO_LOGIN")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(MfaErrorModal);
